import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '@/lib/api';
import { Flame, Trophy } from 'lucide-react';

export default function StreakLeaderboard({ limit = 10 }) {
  const [entries, setEntries] = useState([]);
  const [threshold, setThreshold] = useState(3);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/battles/streak_leaderboard?limit=${limit}`).then(r => {
      setEntries(r.data.leaderboard || []);
      setThreshold(r.data.boost_threshold || 3);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [limit]);

  if (loading) return null;

  return (
    <div className="mt-10" data-testid="streak-leaderboard">
      <div className="flex items-center gap-2 mb-3">
        <Trophy className="w-5 h-5 text-[#FCD535]" />
        <h2 className="text-white text-xl font-semibold">Streak Leaderboard</h2>
        <span className="text-xs uppercase tracking-wider text-[#848E9C]">top predictors this season</span>
      </div>
      {entries.length === 0 ? (
        <div className="border border-[#2B3139] bg-[#181A20] p-6 text-center text-sm text-[#848E9C]">
          No streaks yet. Be the first — vote in the next battle.
        </div>
      ) : (
        <div className="border border-[#2B3139] bg-[#181A20]">
          <div className="grid grid-cols-12 px-4 py-3 text-xs uppercase tracking-wider text-[#848E9C] border-b border-[#2B3139]">
            <div className="col-span-1">#</div>
            <div className="col-span-6">Trader</div>
            <div className="col-span-3">Last win</div>
            <div className="col-span-2 text-right">Streak</div>
          </div>
          {entries.map((e, i) => (
            <Link
              key={e.user_id}
              to={`/trader/${e.user_id}`}
              className="grid grid-cols-12 px-4 py-3 items-center border-b border-[#2B3139]/60 text-sm hover:bg-[#0B0E11]"
              data-testid={`streak-row-${i}`}
            >
              <div className="col-span-1 font-mono text-[#848E9C]">
                {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : `#${i + 1}`}
              </div>
              <div className="col-span-6 flex items-center gap-2 min-w-0">
                {e.picture ? (
                  <img src={e.picture} alt="" className="w-7 h-7 rounded-full flex-shrink-0" />
                ) : (
                  <div className="w-7 h-7 rounded-full bg-[#2B3139] grid place-items-center text-[#EAECEF] text-xs font-semibold flex-shrink-0">
                    {e.name?.[0]?.toUpperCase() || '?'}
                  </div>
                )}
                <div className="text-white truncate">{e.name}</div>
                {e.boosted && (
                  <span className="flex items-center gap-1 px-1.5 py-0.5 text-[10px] font-mono uppercase text-[#F6465D] bg-[#F6465D]/12 border border-[#F6465D]/30">
                    <Flame className="w-3 h-3" /> Boosted
                  </span>
                )}
              </div>
              <div className="col-span-3 text-[#B7BDC6] text-xs uppercase font-mono">{e.last_win_symbol || '—'}</div>
              <div className={`col-span-2 text-right font-mono text-lg ${e.streak >= threshold ? 'text-[#F6465D]' : 'text-[#FCD535]'}`}>
                {e.streak}🔥
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
